<div class="text-center">
  <p class="text text-danger"
    i18n="@@checkout_sdk.error.no_variant">
    checkout_sdk.error.no_variant
  </p>
</div>
